import React , {useState} from 'react';
import './BridalService.scss';
import imgBridal1 from "../../assets/photos/Bridal4.jpg"
import imgBridal2 from "../../assets/photos/Bridal3.jpg"
import imgBridal3 from "../../assets/photos/Bridal1.jpg"
import { Helmet } from "react-helmet-async";

const bridalImgs =  [
      { 
        id: 1, 
        src: imgBridal1, 
        title: "First Fitting", 
        timeNeeded: "1-2 months before your wedding", 
        description: "During your first fitting, we’ll take measurements and discuss adjustments. Bring your wedding shoes and undergarments for the perfect fit!" 
      },
      { 
        id: 2, 
        src: imgBridal2, 
        title: "Adjustment Meeting", 
        timeNeeded: "3-5 weeks before your wedding", 
        description: "We’ll fine-tune the details and make any necessary tweaks to ensure your gown looks and feels amazing." 
      },
      { 
        id: 3, 
        src: imgBridal3, 
        title: "Final Fitting", 
        timeNeeded: "1-2 weeks before your wedding", 
        description: "We’ll do a final fitting to ensure everything is perfect. Walk out feeling confident and ready to shine!" 
      },
    ];


const contentFaqs = [
  {
    question: "How long will my fittings last? How many fittings will I need?",
    answer:
      "Most bridal alterations require 2-3 fittings, each lasting about 30-60 minutes. The exact number depends on the complexity of your alterations and customizations.",
  },
  {
    question: "What should my budget be? How much should I expect to spend?",
    answer:
      "Bridal alterations typically range from $300-$1500, depending on the work needed. We provide a detailed cost estimate during your first fitting.",
  },
  {
    question: "Can I customize my wedding dress?",
    answer:
      "Absolutely! We can add off-the-shoulder straps, sleeves, a bustle, lace appliqués, beadwork, and more. Our expert seamstresses will help you bring your vision to life.",
  },
  {
    question: "What should I bring to my fittings? What should I wear?",
    answer:
      "Bring your wedding shoes and undergarments you plan to wear. This helps us adjust the fit perfectly. You can also bring accessories if you'd like to see how they match your gown.",
  },
  {
    question: "How far in advance should I schedule my first fitting? Do you offer rush services?",
    answer:
      "We recommend scheduling your first fitting at least 2-3 months before your wedding. Rush alterations may be available for an additional fee.",
  },
];

const BridalService = () => {
  const [selectedImage, setSelectedImage] = useState(bridalImgs[0]);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="content-Bridal">
      <Helmet>
        <title>Bridal Alterations | Wedding Dress Tailoring | Cooper City, FL</title>
        <meta name="description" content="Expert bridal alterations for wedding gowns, bridesmaids' dresses, and formal wear. Perfect fit guaranteed for your special day in Cooper City, FL." />
        <link rel="canonical" href="https://www.alterationsbysdenka-paola.com/services/bridal" />
      </Helmet>

        <div className='bridal_head'>
          <h1>Congratulations on your engagement!</h1>
          <p>Your big day is almost here, and we’re here to ensure your wedding dress fits perfectly. Our expert tailors handle precise alterations and customizations, offering stress-free service to bring your vision to life.</p>
          <h2>Let’s make your wedding look unforgettable—one stitch at a time.</h2>
        </div>
      <div className="image-grid">
        {bridalImgs.map((image) => (
          <div key={image.id} className="image-container">
            <img src={image.src} alt={image.title} className="image" />
            <div className="overlay">
                <h2>{image.title}</h2>
                <strong><p>{image.timeNeeded}</p></strong>
                <p>{image.description}</p>
              </div>
          </div>
        ))}
      </div>
      <div className="image-selector_mobile">
        <div className="image-container">
          {bridalImgs.map((image) => (
            <div
              key={image.id}
              className="image-item" 
              onClick={() => setSelectedImage(image)}
            >
              <img src={image.src} alt={image.title} />
              <span className={`image-number ${selectedImage.id === image.id ? "selected" : ""}`}>{image.id}</span>
            </div>
          ))}
        </div>
        <div className="text-container">
          <h2>{selectedImage.title}</h2>
          <strong><p>{selectedImage.timeNeeded}</p></strong>
          <p>{selectedImage.description}</p>
        </div>
      </div>

      <div className="bridal-faq">
        <h2>Frequently Asked Questions for Brides</h2>
        <div>
          {contentFaqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-toggle">{openIndex === index ? "−" : "+"}</span>
              </button>
              {openIndex === index && <p className="faq-answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BridalService;